import styled from "@emotion/styled";

export const ScreenContainer = styled.div`
  width: 900px;
  margin: 0 auto;
  padding: 0 2rem;
  overflow: hidden;
`;

export const Container = styled.div`
  height: 100vh;
  display: grid;
  grid-template-rows: 20% 80%;
`;

//  Logo container
export const LogoContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
`;
export const LogoImage = styled.img`
  height: 80px;
  width: 80px;
`;

export const FormContainer = styled.div`
  display: grid;
  align-items: center;
  align-content: flex-start;
  padding-top: 10px;
  
  
& Form {
  width:100%;
}
  

  
`;
export const H1 = styled.h1`
padding:20px 0px;
text-align:left;
`;

export const InputContainer = styled.div`

margin: 1rem 0;

display: grid;
grid-template-columns: repeat(1, 1fr);
gap: 2rem;

 
`;

export const Input = styled.input``;

export const Div = styled.div``;
export const CreateBtn = styled.button`
  margin-top: 2rem;
  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  
`;

export const SpinnerContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
